import { createRef } from 'react';

/**
 * Global ref for the Chat Input (typing container).
 * Exported separately to avoid breaking React Fast Refresh by mixing component and non-component exports.
 */
export const chatInputRef = createRef();
